"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _components = require("@folio/stripes/components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NumberField = props => {
  const {
    onChange: passedOnChange = _noop.default,
    input,
    value,
    ...rest
  } = props;

  // Treat TextField ALWAYS as a controlled component, whether or not NumberField itself is controlled
  // This enforces the behaviour whereby 1e2 -> 100 in the typed field automatically
  const [forceControl, setForceControl] = (0, _react.useState)(value ?? input?.value);
  const inputRef = (0, _react.useRef)();
  const userInputRef = (0, _react.useRef)();
  const [numValue, setNumValue] = (0, _react.useState)('');
  const changeField = val => {
    (0, _components.nativeChangeFieldValue)(inputRef, false, val);
  };

  // Allow direct control of field
  (0, _react.useEffect)(() => {
    if (value && numValue !== value) {
      setNumValue(value);
    }
    if (numValue && forceControl !== numValue) {
      setForceControl(numValue);
    }
  }, [forceControl, numValue, value]);
  const handleChange = e => {
    // Actually set the value in the form
    if (input?.onChange) {
      input.onChange(e);
    }

    // Set the forced control (this may be wiped by passedOnChange)
    setForceControl(e.target.value);

    // If the user has set up an onChange, this will ensure that that fires
    if (passedOnChange) {
      passedOnChange(e, e.target.value);
    }
  };
  const handleUserChange = e => {
    const parsedValue = parseFloat(e.target.value);

    // ReturnValue needed for contorlled components
    if (parsedValue) {
      setNumValue(parsedValue);
      changeField(parsedValue);
    } else {
      setNumValue('');
      changeField('');
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TextField, {
      ref: userInputRef,
      ...rest,
      // Keep an eye on this
      onChange: handleUserChange,
      type: "number",
      value: forceControl
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ref: inputRef,
      ...input,
      hidden: true,
      onChange: handleChange,
      type: "number",
      value: numValue
    })]
  });
};
NumberField.propTypes = {
  onChange: _propTypes.default.func,
  input: _propTypes.default.shape({
    onChange: _propTypes.default.func.isRequired,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }),
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
var _default = exports.default = NumberField;